import { useAPIQuery } from "../../../../hooks/useAPIQuery";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import RVModal from "./RVModal";
import userData from "../../../Data/user.json";

const UpdatedRVMatrix = () => {
    // React hook form
    const {
        register,
        handleSubmit,
        formState: { dirtyFields },
        reset,
    } = useForm();

    // to set the specific role name and their users
    const [roleName, setRoleName] = useState(null);
    const [usersForRole, setUsersForRole] = useState([]);
    const [privilegeForRole, setPrivilegeForRole] = useState([]);

    // To fetch the users role wise starts here
    const { useFetch: userRoleFetch } = useAPIQuery({
        key: "api/assign-user-role",
        endpoint: "/api/assign-user-role/",
    });

    const { data: userRole } = userRoleFetch({
        params: { action: "fetch-user" },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    // To fetch the users role wise ends here

    // Function to handle role selection and filter users
    const handleRoleClick = (roleName) => {
        setRoleName(roleName);
        const matchedRole = userRole.data.user.find(
            (user) => user.role_name === roleName
        );
        const matchPrivilege = data?.data?.roles.find(
            (user) => user.role_name === roleName
        );
        setPrivilegeForRole(matchPrivilege ? matchPrivilege.privilege : []);
        setUsersForRole(matchedRole ? matchedRole.user : []);
    };

    // To fetch the role and privileges for the matrix starts here
    const { useFetch, useCreate } = useAPIQuery({
        key: "api/roles",
        endpoint: "/api/roles/",
    });

    const { data, isLoading, isFetching, isError } = useFetch({
        params: { action: "rv_matrix" },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    // To fetch the role and privileges for the matrix ends here

    const { mutate, isPending } = useCreate({
        params: { action: "rv_matrix" },
        successMessageFromServer: true,
        errorMessageFromServer: true,
    });

    // Initialize State based on JSON Data
    const [permissions, setPermissions] = useState([]);
    console.log(permissions);

    useEffect(() => {
        // Populate initial state with pre-checked values
        const initialPermissions = data?.data?.privileges?.map((privilege) => {
            const rolePermissions = data?.data?.roles?.reduce((acc, role) => {
                const hasPrivilege = role.privilege.some(
                    (p) => p.privilege_name === privilege
                );
                acc[role.role_name] = hasPrivilege;
                return acc;
            }, {});

            return {
                id: privilege?.id,
                name: privilege?.privilege_name,
                ...rolePermissions,
            };
        });
        console.log(initialPermissions);

        setPermissions(initialPermissions);
    }, [data]);

    const extractDirtyFields = (dirtyFields, submitData) => {
        console.log(dirtyFields);
        console.log(submitData);
        let result = {};

        Object.keys(dirtyFields).forEach((roleId) => {
            dirtyFields[roleId].forEach((field, index) => {
                if (field !== null) {
                    if (!result[roleId]) result[roleId] = {};

                    result[roleId][index] = submitData?.[roleId]?.[index];
                }
            });
        });

        return result;
    };

    const onSubmit = (data) => {
        const fields = extractDirtyFields(dirtyFields, data);
        const res = {
            bulk_upload: Object.keys(fields).map((role) => ({
                role_id: Number(role),
                privilege: Object.keys(fields?.[role])?.map((privilege) => ({
                    id: Number(privilege),
                    assigned: fields?.[role]?.[privilege]?.assigned,
                })),
            })),
        };

        mutate({ data: res });
    };

    console.log(dirtyFields);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content d-flex">
                            <h3 className="nk-block-title page-title">
                                RV Matrix
                            </h3>
                            {isLoading ? (
                                <div
                                    className="spinner-border text-primary ms-2"
                                    role="status"
                                >
                                    <span className="sr-only"></span>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        {/* {privileges.includes("sales_order_create") && ( */}
                        <div className="nk-block-head-content">
                            <button
                                type="submit"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-rv-matrix"
                            ></button>

                            <button
                                type="submit"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-rv-matrix"
                            >
                                <span>
                                    {isPending ? "loading..." : "Update"}
                                </span>
                            </button>
                        </div>
                        {/* )} */}
                    </div>
                </div>
                <div className="card">
                    <div className="card-inner p-0 m-0">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Privileges</th>
                                        {data?.data?.roles?.map(
                                            (role, index) => (
                                                <th
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modalDefault"
                                                    onClick={() =>
                                                        handleRoleClick(
                                                            role?.role_name
                                                        )
                                                    }
                                                    key={index}
                                                >
                                                    {role?.role_name}
                                                </th>
                                            )
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {permissions?.map(
                                        (privilegeData, privilegeIndex) => (
                                            <tr key={privilegeIndex}>
                                                <td>{privilegeData.name}</td>
                                                {data?.data?.roles?.map(
                                                    (role, roleIndex) => {
                                                        const isDirty =
                                                            !!dirtyFields[
                                                                `${role?.id}`
                                                            ]?.[
                                                                `${privilegeData?.id}`
                                                            ]?.assigned;
                                                        return (
                                                            <td
                                                                key={roleIndex}
                                                                style={{
                                                                    textAlign:
                                                                        "center",
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    defaultChecked={
                                                                        role?.privilege?.filter(
                                                                            (
                                                                                privilege
                                                                            ) =>
                                                                                privilege?.id ===
                                                                                privilegeData?.id
                                                                        )
                                                                            ?.length !==
                                                                        0
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    style={{
                                                                        accentColor:
                                                                            isDirty
                                                                                ? "red"
                                                                                : "",
                                                                    }}
                                                                    {...register(
                                                                        `${role?.id}.${privilegeData?.id}.assigned`
                                                                    )}
                                                                />
                                                            </td>
                                                        );
                                                    }
                                                )}
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </form>

            <RVModal
                roleName={roleName}
                usersForRole={usersForRole}
                privilegeForRole={privilegeForRole}
            />
        </>
    );
};

export default UpdatedRVMatrix;
